/**
 * @description fetches the list of knowledge center entries and groups them by category id
 */

import { queryOptions } from '@tanstack/react-query';
import keyBy from 'lodash/keyBy';

import decodeJson from '@seccon/shared/utils/decodeJson';
import ApiError from '@seccon/shared/utils/ApiError';

import { CATEGORIES } from '../constants';

const CATEGORY_MAP = keyBy(CATEGORIES, (entry) => entry.value);

function fetchKnowledge () {
  return queryOptions({
    queryKey: ['fetchKnowledge'],
    queryFn: () => (
      fetch('/KnowledgeCenter/list')
        .then(decodeJson)
        .then((resp) => {
          const list = {};

          // Iterate through the list of entries and group them by category id
          for (const entry of resp) {
            // If the category exists in the list of modules, use that category id. Otherwise, default to "Other"
            const category = entry.category in CATEGORY_MAP ? entry.category : 'Other';

            // Create a new knowledge list for that category, if one does not exist anymore
            list[category] = list[category] || [];

            // Add that knowledge entry to the knowledge list
            list[category].push(entry);
          }

          // Sort the knowledge map alphabetically by id
          return Object.keys(list)
            .sort()
            .reduce((sortedList, key) => ({ ...sortedList, [key]: list[key] }), {});
        })
        .catch(({ body, status }) => {
          throw new ApiError('Unable to fetch knowledge center entries. Please reload the page and try again', body, status);
        })
    )
  });
}

export default fetchKnowledge;
